import React from 'react';
import { connect } from 'react-redux';

import './styles.scss';

const normalizeWhitespace = html => html?.replace(/\s+/g, ' ').trim();

const FAQ = ({ faq }) => (
  <div
    className="faqMainWrapper appendTop40"
    dangerouslySetInnerHTML={{ __html: normalizeWhitespace(faq) }}
    suppressHydrationWarning
  />
);

const mapStateToProps = ({ seo }) => ({
  faq: seo?.metaData?.faq,
});

export default connect(mapStateToProps, null)(FAQ);
